import { useEffect } from 'react'

/** Use this hook on pages where the Zendesk widget should not be displayed. */
const useHideZendeskWidget = () => {
  useEffect(() => {
    let intervalId

    const hideWidget = () => {
      if (window.zE) {
        window.zE('messenger', 'hide')
        return true
      }

      return false
    }

    // Como o script do Zendesk carrega de forma assíncrona (async no index.html),
    // window.zE pode ainda não existir quando o componente monta.
    if (!hideWidget()) {
      let attempts = 0
      const maxAttempts = 50 // ~10 segundos (50 x 200 ms)

      intervalId = setInterval(() => {
        attempts++

        if (hideWidget() || attempts >= maxAttempts) {
          clearInterval(intervalId)
        }
      }, 200)
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [])
}

export default useHideZendeskWidget
